import React from "react";

import { Global } from "@emotion/react";

import * as styles from "./PageWrapper.styles";


interface PageWrapperProps {
  centered?: boolean;
  children: React.ReactNode;
  hideFooter?: boolean;
  style?: React.CSSProperties;
}

export default function PageWrapper({
  centered,
  children,
  hideFooter = false,
  style
}: PageWrapperProps) {

  return (
    <>
      {
        hideFooter && (
          <Global styles={styles.hideFooter} />
        )
      }
      <div
        css={[
          styles.base,
          centered && styles.centered,
          style && { ...style }
        ]}>
        {children}
      </div>
    </>
  );
}
